export const en = {
  sidebar: {
    collapse: 'Collapse',
    expand: 'Expand',
    settings: 'Settings',
    auditLog: 'Audit Log',
  },

  signIn: {
    emailField: {
      label: 'Email',
      placeholder: 'Your email address',
    },
    passwordField: {
      label: 'Password',
      placeholder: 'Your password',
    },
    submit: 'Continue',

    // CTA
    or: 'OR',
    noAccount: "Don't have an account?",
    bookDemo: 'Book a Demo!',

    errors: {
      invalid: 'Invalid credentials. Check your email/password and try again.',
    },

    success: 'Login Successful!',
  },

  orgSelection: {
    title: 'Select Organization',
    subtitle: 'Choose the organization you want to access',

    orgField: {
      label: 'Select Organization',
      placeholder: 'Select Organization',
    },

    submit: 'Continue',
    goBack: 'Back to Login',

    errors: {
      invalid: 'Invalid organization selection. Please try again.',
    },
  },

  totp: {
    title: 'Two-Factor Authentication',
    subtitle: 'Enter the 6-digit code from your authenticator app',
    qrSetup: {
      title: 'Scan this QR code with your authenticator app',
    },
    submit: {
      verify: 'Verify Code',
      setup: 'Complete Setup',
    },
    goBack: 'Back to Login',
    errors: {
      invalid: 'Invalid verification code. Please try again.',
    },
  },

  emailVerification: {
    title: 'Verify Your Email',
    subtitle: 'Enter the 6-digit code sent to your email address',
    submit: 'Verify Code',
    goBack: 'Back to Login',
    errors: {
      invalid: 'Invalid verification code. Please try again.',
    },
  },

  sessionRefresh: {
    reconnecting: 'Attempting to Reconnect',
    cancel: 'Cancel',
  },

  versionMismatch: {
    title: 'New Version Available',
    description:
      'The application has been updated. Please refresh to get the latest version.',
    action: 'Refresh Now',
  },

  topbar: {
    signOut: 'Sign out',
    assistant: 'ReAI',
    facility: 'Facility',
  },

  address: {
    fields: {
      streetAddress: 'Street Address',
      city: 'City',
      state: 'State',
      postalCode: 'Postal Code',
      country: 'Country',
    },
    placeholders: {
      streetAddress: 'Enter street address',
      city: 'Enter city',
      state: 'Enter state',
      postalCode: 'Enter postal code',
      country: 'Enter country',
    },
    errors: {
      geocodingFailed: 'Failed to get address details. Please try again.',
    },
  },
};
